module.exports = __webpack_public_path__ + "img/bg-view-shadowbox.c7709ffb.png";